<section class="service_sec affiliation" id="affiliation" data-scroll-section>
  <div
    class="img_wraper"
    data-scroll
    data-scroll-repeat
    data-scroll-sticky
    data-scroll-target="#affiliation"
  >
    <span data-scroll data-scroll-speed="1.5">
      <figure
        class="section_img lazyloaded"
        style="background-image: url('assets/about-page/join_us.jpg')"
      ></figure>
    </span>
  </div>
  <div class="row align">
    <div class="content_div award_div" data-scroll data-scroll-speed="1">
      <div class="sec_head">
        <h2>Resume</h2>
      </div>
      <p>
        Experienced Full-Stack Developer with 5+ years of expertise in building scalable web
        applications, REST APIs, and cloud-based solutions. Proficient in Angular, Node.js, AWS, and
        MongoDB, I create fast, user-focused digital products that drive business growth and
        performance.
      </p>
    </div>
    <div class="col_item align" data-scroll-container>
      <div class="col-lg-6">
        <div class="resume">
          <h3 class="resume-title">Summary</h3>
          <div class="resume-item" #resumeItems>
            <h4>Hardik Godhani</h4>
            <p>
              <em>Senior Full Stack Engineer • Tech Consultant</em>
            </p>
            <ul class="resume_list">
              <li>
                My role is to develop and maintain reusable components and libraries in angular and
                node. So other developers can integrate in this organization.
              </li>
            </ul>
          </div>
        </div>
        <div class="resume">
          <h3 class="resume-title">Education</h3>
          <div class="resume-item" #resumeItems>
            <h4>Bachelor of Computer Engineering</h4>
            <p>
              <em>Gujarat Technological University – Gujarat, India (2019)</em>
            </p>
            <ul class="resume_list">
              <li>Graduated with Distinction.</li>
              <li>
                Engaged in various software projects and coding competitions to hone analytical and
                programming skills.
              </li>
            </ul>
          </div>
        </div>
        <div class="resume">
          <h3 class="resume-title">Professional Experience</h3>
          <div class="resume-item" #resumeItems>
            <h4>Lead Full Stack Engineer</h4>
            <p>
              <em>Omcosmos Pty. Ltd. – Australia (December 2024 – Present)</em>
            </p>
            <ul class="resume_list">
              <li>
                Architected and deployed a parcel delivery system using Angular and Node.js, cutting
                operational costs by 40%.
              </li>
              <li>
                Integrated Stripe for payroll automation and GPS tracking for optimized delivery
                routes.
              </li>
              <li>
                Enhanced delivery accuracy by 30% and improved customer satisfaction with real-time
                vehicle tracking.
              </li>
            </ul>
          </div>
        </div>
        <div class="resume">
          <h3 class="resume-title">Professional Experience</h3>
          <div class="resume-item" #resumeItems>
            <h4>Senior Full Stack Developer</h4>
            <p>
              <em>Nexotips Infotech – India (June 2021 – November 2024)</em>
            </p>
            <ul class="resume_list">
              <li>
                Managed a team of 12 developers delivering scalable applications for US and EU
                clients.
              </li>
              <li>
                Rebuilt the company website using Angular 14, implementing MFA and payment gateway
                integrations.
              </li>
              <li>
                Delivered key projects for City BBQ, Khontext, and Adoreal with a focus on
                scalability and accessibility.
              </li>
            </ul>
          </div>
        </div>
        <div class="resume">
          <h3 class="resume-title">Professional Experience</h3>
          <div class="resume-item" #resumeItems>
            <h4>Full Stack Developer</h4>
            <p>
              <em>Codezee Solutions Pvt. Ltd. – India (May 2020 – May 2021)</em>
            </p>
            <ul class="resume_list">
              <li>
                Developed robust backend APIs and dynamic Angular UIs for asset management and B2B
                e-commerce platforms.
              </li>
              <li>
                Contributed to projects like Pridikt and Parko with full-stack ownership, improving
                performance and UI/UX.
              </li>
            </ul>
          </div>
        </div>
        <div class="resume">
          <h3 class="resume-title">Professional Experience</h3>
          <div class="resume-item" #resumeItems>
            <h4>Frontend Developer (Intern → Junior Developer)</h4>
            <p>
              <em>Corona Infotech LLP – India (February 2019 – March 2020)</em>
            </p>
            <ul class="resume_list">
              <li>
                Built a complete parking management system for Atlanta Parking Services with Angular
                and Node.js.
              </li>
              <li>
                Integrated GPS mapping, NMI payments, and secure login mechanisms to enhance
                operational workflow.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="progress-col">
        <div class="col-lg-6">
          <div class="resume">
            <div class="resume-dot"></div>
          </div>
          <div class="resume">
            <div class="resume-dot"></div>
          </div>
          <div class="resume">
            <div class="resume-dot"></div>
          </div>
          <div class="resume">
            <div class="resume-dot"></div>
          </div>
          <div class="resume">
            <div class="resume-dot"></div>
          </div>
        </div>
        <div class="progress-bar" [style.width.%]="scrollProgress"></div>
      </div>
    </div>
  </div>
</section>
